import styled from 'styled-components'

const ConversationListEmptyDescription = styled.div`
	font-size: 18px;
	text-align: center;
`

export default ConversationListEmptyDescription